import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class CartQuantity extends kr.Component {
    init() {
        this.$updateButton = this.$element.parentNode.parentNode.parentNode.querySelector('button[name="update_cart"]');
        this.bind();
    }

    bind()
    {
        this.on('click', '.js-down', (target, event) => {
            event.preventDefault();
            
            const input = target.parentNode.querySelector('.buymodal__quantity__input');
            const min = input.getAttribute('min');
            if (input.value == min) {
                return false;
            }

            input.value = parseInt(input.value) - 1;
            this.$updateButton.removeAttribute('disabled');
        });
        
        this.on('click', '.js-up', (target, event) => {
            event.preventDefault();
            const input = target.parentNode.querySelector('.buymodal__quantity__input');
            const max = input.getAttribute('max');
            if (input.value == max) {
                return false;
            }
            input.value = parseInt(input.value) + 1;
            this.$updateButton.removeAttribute('disabled');
        });
    }
}

kr.registerComponent('.woocommerce-cart-form .js-cartQuantity', {
    component: CartQuantity
});
